
export const cognitiveSkillsList = [
  {
    id: "1",
    skill: "Problem Solving",
    weightage: 20,
    description:
      "The ability to identify issues, analyze causes, and implement effective solutions."
  },
  {
    id: "2",
    skill: "Critical Thinking",
    weightage: 20,
    description:
      "Applying logic and reasoning to evaluate arguments, evidence, and information to form well-reasoned judgments."
  },
  {
    id: "3",
    skill: "Decision Making",
    weightage: 20,
    description:
      "Making timely decisions based on available information and considering potential outcomes."
  },
  {
    id: "4",
    skill: "Evaluation",
    weightage: 20,
    description:
      "The ability to assess information critically, make judgments, and determine the credibility of sources"
  },
  {
    id: "5",
    skill: "Creation",
    weightage: 20,
    description:
      "The ability to combine various pieces of information, ideas, and concepts to create something new."
  }
];

export const suggestedSkills = [
  "C#/ASP.NET",
  "Typescript/JavaScript",
  "React",
  "NextJS/NodeJs",
  "Python",
  "Java",
  "Go",
  "Postgres/MySQL/SQL Server",
  "AWS",
  "Azure",
  "GCP"
];
